<button class="btn btn-sm btn-custom-pri float-end" title="Refresh" id="{{idString}}" (click)="refreshClickEvent()"><i
        class="fa-classic fa-solid fa-arrows-rotate fa-fw"></i></button>